import { isOfferExpired } from './offerStatus';

const MY_LIST_KEY = 'raheasy_my_list';

export const getListProductId = (product) =>
  String(product?.id || product?._id || '');

export const loadMyList = () => {
  try {
    const raw = localStorage.getItem(MY_LIST_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const saveMyList = (items) => {
  localStorage.setItem(MY_LIST_KEY, JSON.stringify(items));
};

const snapshotProductForList = (product) => {
  if (!product) return null;
  const id = getListProductId(product);
  if (!id) return null;

  let image = product.thumbnail || product.image || '';
  if (
    !image &&
    Array.isArray(product.images) &&
    product.images.length > 0
  ) {
    const primaryIndex =
      product.primaryImageIndex !== undefined &&
      product.primaryImageIndex < product.images.length
        ? product.primaryImageIndex
        : 0;
    image = product.images[primaryIndex];
  }

  return {
    id,
    _id: product._id || product.id,
    name: product.name,
    price: product.price,
    originalPrice: product.originalPrice,
    image,
    thumbnail: product.thumbnail,
    images: product.images,
    imageFallbacks: product.imageFallbacks,
    imagekitImages: product.imagekitImages,
    thumbnailFallback: product.thumbnailFallback,
    thumbnailImagekit: product.thumbnailImagekit,
    primaryImageIndex: product.primaryImageIndex,
    urlSlug: product.urlSlug,
    brand: product.brand,
    sku: product.sku,
    storeName: product.storeName,
    storeId: product.storeId,
    vendor: product.vendor,
    vendorProductUrl: product.vendorProductUrl,
    vendorChatUrl: product.vendorChatUrl,
    offerStartsAt: product.offerStartsAt,
    offerEndsAt: product.offerEndsAt,
    newBadgeDays: product.newBadgeDays,
    endingSoonBadgeDays: product.endingSoonBadgeDays,
    createdAt: product.createdAt,
    inStock: product.inStock,
    addedAt: Date.now(),
  };
};

export const addProductToList = (currentList, product) => {
  const snapshot = snapshotProductForList(product);
  if (!snapshot) return currentList;

  const exists = currentList.some(
    (item) => getListProductId(item) === snapshot.id
  );
  if (exists) return currentList;

  return [...currentList, snapshot];
};

export const removeProductFromList = (currentList, productId) =>
  currentList.filter((item) => getListProductId(item) !== String(productId));

export const isProductInList = (list, product) => {
  const id = getListProductId(product);
  if (!id) return false;
  return list.some((item) => getListProductId(item) === id);
};

export const createListProductIdSet = (list) =>
  new Set(list.map((item) => getListProductId(item)).filter(Boolean));

export const MAX_SHARED_SAVED_DEALS = 40;

export const getShareableSavedDeals = (items = []) =>
  (items || []).filter((item) => item && !isOfferExpired(item)).slice(0, MAX_SHARED_SAVED_DEALS);

export const encodeSavedDealIdsParam = (items = []) =>
  getShareableSavedDeals(items)
    .map((item) => getListProductId(item))
    .filter(Boolean)
    .join(',');

export const parseSavedDealIdsParam = (search = '') => {
  const params = new URLSearchParams(search);
  const raw = params.get('ids');
  if (!raw) return [];
  return raw
    .split(',')
    .map((id) => String(id || '').trim())
    .filter(Boolean)
    .slice(0, MAX_SHARED_SAVED_DEALS);
};

export const buildSavedDealsShareUrl = (items = [], origin = '') => {
  const ids = encodeSavedDealIdsParam(items);
  if (!ids) return '';
  const base =
    origin ||
    (typeof window !== 'undefined' && window.location?.origin) ||
    '';
  return `${base}/saved?ids=${encodeURIComponent(ids)}`;
};

export const mergeSharedSavedDeals = (currentList, ids, catalogProducts = []) => {
  if (!Array.isArray(ids) || !ids.length) {
    return { list: currentList, addedCount: 0 };
  }
  const catalogById = new Map(
    (catalogProducts || []).map((product) => [getListProductId(product), product])
  );
  let list = Array.isArray(currentList) ? currentList : [];
  let addedCount = 0;
  ids.forEach((rawId) => {
    const product = catalogById.get(String(rawId || '').trim());
    if (!product) return;
    const next = addProductToList(list, product);
    if (next !== list) addedCount += 1;
    list = next;
  });
  return { list, addedCount };
};
